<button (click)="toggleExpanded()" motifButton color="link-alt" size="small" [attr.aria-label]="getAriaLabel()">
  {{ label() }}<motif-icon size="20" [iconFunction]="icon()" />
</button>
